import { Grid, useTheme, Theme, Typography, Box, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { ViolationCheckState } from "@vmosolutions/oc-interfaces";
import { formatDateString } from "src/components/DateDisplay";
import classNames from "classnames";
import { LoadingMessage } from "src/components/LoadingMessage/LoadingMessage";
import chroma from "chroma-js";
import { useMemo } from "react";

interface ICrewViolationProps {
  id: string;
  path: string[];
  crewId: string;
}

export const CrewViolationLastScan = (props: ICrewViolationProps): JSX.Element => {
  const { crewId } = props;
  const violationCheckStatus = useSelector((state: IRootState) => state.crewSchedule.violationCheckStatus[crewId]);
  const scanStatus = useMemo((): {
    message: string;
    color: "info" | "success" | "warning" | "error" | "default" | "primary" | "secondary";
  } => {
    if (violationCheckStatus?.lastState === ViolationCheckState.Inprogress) {
      return { message: "In Progress", color: "info" };
    } else if (violationCheckStatus?.lastState === ViolationCheckState.Success) {
      return { message: "Successful", color: "success" };
    } else if (violationCheckStatus?.lastState === ViolationCheckState.Failed) {
      return { message: "Failed", color: "error" };
    } else {
      return { message: "Unknown", color: "info" };
    }
  }, [violationCheckStatus]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={(theme) => ({
          backgroundColor: chroma(theme.palette.background.default).darken(0.5).css(),
          p: 0.5,
          pl: 2,
          borderBottom: `1px solid  ${chroma(theme.palette.background.default).brighten(0.5).css()}`,
        })}
      >
        Crew Violation Scan Status
      </Grid>

      <Grid container spacing={1} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Grid item xs={5} sx={{ textAlign: "right", fontSize: "0.8em" }}>
          Last Scanned:
        </Grid>
        <Grid item xs={7} sx={{ textAlign: "left", fontSize: "0.8em" }}>
          {violationCheckStatus?.date ? formatDateString(violationCheckStatus?.date, "Etc/UTC") : "Unknown"}
        </Grid>
        <Grid item xs={5} sx={{ textAlign: "right", fontSize: "0.8em" }}>
          Scan Status:
        </Grid>
        <Grid item xs={7} sx={{ textAlign: "left", fontSize: "0.8em" }}>
          {violationCheckStatus?.lastState === ViolationCheckState.Inprogress ? (
            <LoadingMessage message={scanStatus.message} />
          ) : (
            <Chip
              label={scanStatus.message}
              color={scanStatus.color}
              variant="filled"
              size="small"
              sx={{
                borderRadius: "3px",
                fontWeight: 900,
                textTransform: "uppercase",
                fontSize: "0.9em",
              }}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
